module.exports = __webpack_public_path__ + "../assets/img/cbae54ea870f876b55d364b0162ce6ca.svg";